import {
    DATA, DELTA, GENERAL, PRIMARY_NAV_CLICK, PROFILE, RESULTS, SECONDARY_NAV_NEXT_CLICK, SECONDARY_NAV_PREVIOUS_CLICK,
    TECHNIQUES
} from '../constants';

export interface NavReducerState {
    navId: string;
}

interface Payload {
    navId: string;
    deltaId: string;
}

interface Action {
    type: string;
    payload: Payload;
}

const initialState = {
    navId: PROFILE
};

function getNextDeltaId(deltaId: string) {
    switch (deltaId) {
        case TECHNIQUES:
            return RESULTS;
        default:
            return DELTA;
    }
}

function getPreviousDeltaId(deltaId: string) {
    switch (deltaId) {
        case DATA:
            return GENERAL;
        default:
            return DELTA;
    }
}

function getNextNavId(navId: string, deltaId: string) {
    switch (navId) {
        case PROFILE:
            return GENERAL;
        case GENERAL:
            return DELTA;
        case DELTA:
            return getNextDeltaId(deltaId);
        default:
            return navId;
    }
}

function getPreviousNavId(navId: string, deltaId: string) {
    switch (navId) {
        case GENERAL:
            return PROFILE;
        case DELTA:
            return getPreviousDeltaId(deltaId);
        case RESULTS:
            return DELTA;
        default:
            return navId;
    }
}

const navReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case PRIMARY_NAV_CLICK:
            const navId = action.payload.navId;

            return {
                ...state,
                navId
            };
        case SECONDARY_NAV_NEXT_CLICK:
            return {
                ...state,
                navId: getNextNavId(state.navId, action.payload.deltaId)
            };
        case SECONDARY_NAV_PREVIOUS_CLICK:
            return {
                ...state,
                navId: getPreviousNavId(state.navId, action.payload.deltaId)
            };
        default:
            return {
                ...state
            };
    }
};

export default navReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/navReducer.ts